import { render, staticRenderFns } from "./CoAPreview.vue?vue&type=template&id=3be88d94&scoped=true"
import script from "./CoAPreview.vue?vue&type=script&lang=js"
export * from "./CoAPreview.vue?vue&type=script&lang=js"
import style0 from "./CoAPreview.vue?vue&type=style&index=0&id=3be88d94&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be88d94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be88d94')) {
      api.createRecord('3be88d94', component.options)
    } else {
      api.reload('3be88d94', component.options)
    }
    module.hot.accept("./CoAPreview.vue?vue&type=template&id=3be88d94&scoped=true", function () {
      api.rerender('3be88d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/CoAPreview.vue"
export default component.exports